import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const BarSimpleIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        style={customStyle}
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 3v18M17 7v14M7 10v11"
        ></path>
      </svg>
    </div>
  );
};

export default BarSimpleIcon;
